import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Address\GetAddressListController::__invoke
* @see app/Http/Controllers/Address/GetAddressListController.php
* @route '/api/address'
*/
const GetAddressListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAddressListController.url(options),
    method: 'get',
})

GetAddressListController.definition = {
    methods: ["get","head"],
    url: '/api/address',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Address\GetAddressListController::__invoke
* @see app/Http/Controllers/Address/GetAddressListController.php
* @route '/api/address'
*/
GetAddressListController.url = (options?: RouteQueryOptions) => {
    return GetAddressListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Address\GetAddressListController::__invoke
* @see app/Http/Controllers/Address/GetAddressListController.php
* @route '/api/address'
*/
GetAddressListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAddressListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Address\GetAddressListController::__invoke
* @see app/Http/Controllers/Address/GetAddressListController.php
* @route '/api/address'
*/
GetAddressListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAddressListController.url(options),
    method: 'head',
})

export default GetAddressListController